import createReducer from '../utils/createReducer';
import {
  PROJECT_SPECIFICATIONS_REQUEST,
  PROJECT_SPECIFICATIONS_FAILURE,
  PROJECT_SPECIFICATIONS_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [PROJECT_SPECIFICATIONS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [PROJECT_SPECIFICATIONS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [PROJECT_SPECIFICATIONS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/projectSpecifications.js